import React, { FC } from 'react';
import { Landing } from './Landing';

export const App: FC = () => {
  return <Landing />;
};
